export enum HeaderHeight {
  AboveDesktop = '78px',
  Desktop = '58px',
}
